// extracted by mini-css-extract-plugin
module.exports = {"content":"_103a151b99--content--U69Gh","text":"_103a151b99--text--oCFxT","subtitle":"_103a151b99--subtitle--wRa98","img":"_103a151b99--img--kICdc"};